import { useCallback } from 'react';

import usePressTracing from '@atlaskit/react-ufo/use-press-tracing';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

import { useLoomEntryPointVariantActions } from './useLoomEntryPointVariantState';

export type EntryPointId = 'poConfluenceSideNavCreate';

export const SOURCE_COMPONENT: EntryPointId = 'poConfluenceSideNavCreate';

type triggerCrossFlowSuccessCheckType = {
	onCrossflowFailure?: () => void;
};

interface Props {
	sourceComponent: EntryPointId;
}

export const useTriggerCrossFlowSuccessCheck = ({ sourceComponent }: Props) => {
	const { crossFlowSuccessCheck } = useLoomEntryPointVariantActions();
	const { cloudId } = useSessionData();
	const tracePolling = usePressTracing('loom.cross-flow.license-information.poll');
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const triggerCrossFlowSuccessCheck = useCallback(
		({ onCrossflowFailure }: triggerCrossFlowSuccessCheckType) => {
			// cross-flow would only be able to update the variant if the user is an admin
			// end-users get taken through request-trial flow, which does not provision Loom

			tracePolling(); // trigger the UFO tracing to start
			crossFlowSuccessCheck({
				cloudId,
				onCrossflowFailure,
				createAnalyticsEvent,
				sourceComponent,
			});
		},
		[tracePolling, crossFlowSuccessCheck, cloudId, createAnalyticsEvent, sourceComponent],
	);

	return { triggerCrossFlowSuccessCheck };
};
